export default function validate(data) {
    let errors = {};

    if (!data.tariff) {
        errors.tariff = 'tariff_error';
    }

    return errors
}